import React from "react";
import logger from "logger";
import TaskletCard from "TaskHistory/Tasklet/Tasklets/TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import * as TaskService from "Utils/TaskService";
import { ServiceToggle } from "./ServiceToggle";

export default function(props) {
  const { accountdetail, accountdetailrow } = props;

  const autobubbletoggle = () => {
    if (accountdetail.autobubble) {
      TaskService.removeAccountFromAutoBubble(accountdetailrow);
    } else {
      TaskService.addAccountToAutoBubble(accountdetailrow);
    }
  };

  const autocalendartoggle = () => {
    if (accountdetail.autocalendar) {
      TaskService.removeAccountFromAutoCalendar(accountdetailrow);
    } else {
      TaskService.addAccountToAutoCalendar(accountdetailrow);
    }
  };

  const autoclaimprizestoggle = () => {
    if (accountdetail.autoclaimprizes) {
      TaskService.removeAccountFromAutoClaimPrizes(accountdetailrow);
    } else {
      TaskService.addAccountToAutoClaimPrizes(accountdetailrow);
    }
  };

  const autoentrustdonatetoggle = () => {
    if (accountdetail.autodonate) {
      TaskService.removeAccountFromAutoDonate(accountdetailrow);
    } else {
      TaskService.addAccountToAutoDonate(accountdetailrow);
    }
  };

  return (
    <TaskletCard>
      <CardContent>
        <div className="headline">Services</div>
        <br />
        <div style={{ display: "inline-grid" }}>
          <ServiceToggle
            label={"AutoBubble"}
            tooltip={
              <p>
                Keeps track of your bubble and pops bubble whenever it expires.
                <br />
                Bubble runes will be used in order of 12 hr, 8 hr and 2 hours(If
                one is not available other will be used).
              </p>
            }
            onClick={autobubbletoggle}
            value={accountdetail.autobubble}
          />
          <ServiceToggle
            label={"AutoCalender"}
            tooltip={
              <p>Auto logs in to Calendar within one hour of new day start.</p>
            }
            onClick={autocalendartoggle}
            value={accountdetail.autocalendar}
          />
          <ServiceToggle
            label={"AutoClaimPrizes"}
            tooltip={
              <p>
                Auto claims all prizes from event center within one hour of new
                day.
              </p>
            }
            onClick={autoclaimprizestoggle}
            value={accountdetail.autoclaimprizes}
          />
          <ServiceToggle
            label={"AutoEntrustDonate"}
            tooltip={
              <p>
                Auto Entrusts/Donates to get Alliance Points within one hour of
                new day start.
              </p>
            }
            onClick={autoentrustdonatetoggle}
            value={accountdetail.autodonate}
          />
        </div>
      </CardContent>
    </TaskletCard>
  );
}
